/* istanbul ignore file */
import { action, observable } from 'mobx';

import { Expand, BasemapGallery } from 'cd-eft/utils/esriTypes';

export class BasemapVM {
  @observable props: any;
  current: any;
  constructor(props: any) {
    this.props = props;
  }
  @observable basemap = undefined;

  @action.bound async basemapMount(props) {
    if (!props.view.when) {
      return null;
    }

    try {
      props.view.when(() => {
        const basemapGallery = new BasemapGallery({
          view: props.view,
          source: {
            portal: {
              url: 'https://www.arcgis.com',
              useVectorBasemaps: true, // Load vector tile basemaps
            },
          },
        });

        const bmgExpand = new Expand({
          view: props.view,
          content: basemapGallery,
          container: 'basemap-gallery-div',
        });

        // close the expand whenever a basemap is selected
        basemapGallery.watch('activeBasemap', () => {
          const mobileSize = props.view.heightBreakpoint === 'xsmall' || props.view.widthBreakpoint === 'xsmall';

          if (mobileSize) {
            bmgExpand.collapse();
          }
        });
      });
    } catch (err) {
      console.error(err);
    }
  }
}
